import { AssetsProvider, Image, mobile, styled } from '@obvio/app'
import { Reveal } from '@obvio/ui'
import { motion } from 'framer-motion'

import type { ImageAsset } from '@obvio/app'
import type { ReactElement } from 'react'

const RevealSection = styled.section`
  height: 59rem;

  @media ${mobile} {
    height: 24.5rem;
    padding: 0 ${(theme) => theme.spacing.small};
  }
`

const MotionRevealSection = motion(RevealSection)

type EventRevealProps = {
  image: ImageAsset
  id: string
}

export function EventReveal({ image, id }: EventRevealProps): ReactElement {
  return (
    <AssetsProvider path={`/event/${id}`}>
      <MotionRevealSection
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <Reveal color="#0f0f0f" posX={0.3} posY={0.5}>
          <Image img={image} />
        </Reveal>
      </MotionRevealSection>
    </AssetsProvider>
  )
}
